import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/repo/apps/trading-arena/app/ClientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/trading-arena/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/repo/apps/trading-arena/src/context/ConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/repo/apps/trading-arena/src/context/ThemeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/repo/apps/trading-arena/src/context/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/@cbhq/cds-web/esm/styles/global.css");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/@cbhq/cds-web/esm/styles/defaultFont.css");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/@cbhq/cds-icons/esm/fonts/web/icon-font.css");
